import { Component, HostBinding } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { APP_VERSION } from 'src/environments/version';
import { LoadingService } from './core/services/load.service';
import { LoginService } from './core/services/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  public readonly APP_VERSION = APP_VERSION;
  private isDark = false;
  public isLogged = false;

  @HostBinding('class')
  get themeMome() {
    return this.isDark ? 'theme-dark' : 'theme-light';
  }
  title = 'Sollo Business';
  showLoading: boolean = false;

  constructor(
    loginService: LoginService,
    loadService: LoadingService,
    translation: TranslateService
  ) {
    loginService.authState.subscribe((s) => (this.isLogged = s));

    loadService.showLoad.subscribe((l) => (this.showLoading = l));
    translation.setDefaultLang(translation.getBrowserCultureLang()!);
  }
}
